/**
 * Normalise une saisie vers les 10 chiffres d’un numéro français national (0XXXXXXXXX).
 * Gère collage type +33 6 … → 06…  + troncat à 10 chiffres.
 */
export function normalizeFrPhoneToNationalDigits(raw: string): string {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('33') && digits.length >= 10) {
    digits = `0${digits.slice(2)}`;
  }
  return digits.slice(0, 10);
}

/** Affiche par groupes de 2 après l’indicatif initial (ex. 06 12 34 56 78). */
export function formatFrNationalGroupedDigits(digitsOnly: string): string {
  const d = digitsOnly.replace(/\D/g, '').slice(0, 10);
  if (!d) return '';
  const head = d.slice(0, 2);
  const tail = d.slice(2);
  const pairs = tail.match(/.{1,2}/g) ?? [];
  return [head, ...pairs].join(' ');
}
